/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhookEndpointsUpdate } from "../../funcs/webhookEndpointsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateWebhookEndpointRequest$inboundSchema,
};

export const tool$webhookEndpointsUpdate: ToolDefinition<typeof args> = {
  name: "webhook-endpoints-update",
  description: `Update Webhook Endpoint

Update a webhook endpoint's name, URL, or active status. Use this to rotate endpoints or temporarily disable delivery without deleting the endpoint.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhookEndpointsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
